// Imports
import { Privilege } from '../privileges';


/** Determines if a given privilege is contained within the list of provided member privileges */
export default function memberHasPrivilege(privilege: Privilege, memberPrivileges: Privilege[]) {
	return memberPrivileges.includes(privilege) || memberPrivileges.includes('*');
}
